// extracted by mini-css-extract-plugin
export default {"drawerFooter":"styles_drawerFooter__QpOQt","drawerFooterLabel":"styles_drawerFooterLabel__qiHjq"};